// extracted by mini-css-extract-plugin
export default {"container":"Home_container__GtCQ6","wrapperBox":"Home_wrapperBox__FoUbx","card":"Home_card__hU3YQ","footer":"Home_footer__bq2qo"};